import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateUserPassPutRequestModel, UpdateUserPassPutResponseModel } from "@/features/user/services/user-model";

export class UpdateUserPassApi {
  /**
   * 利用者パスワード変更API
   */
  public putUpdateUserPass = async (
    param: UpdateUserPassPutRequestModel
  ): Promise<UpdateUserPassPutResponseModel> => {
    const path = `/api/users/updatepw`;

    const res = await ApiClient.instance.put<UpdateUserPassPutResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
